import { render, staticRenderFns } from "./CellRendererOfficine.vue?vue&type=template&id=9086842a&"
import script from "./CellRendererOfficine.vue?vue&type=script&lang=js&"
export * from "./CellRendererOfficine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports